module.exports = __webpack_public_path__ + "static/media/email-green.2361e00e.svg";